<div class="label">
  <span *ngIf="basisCode">{{ basisCode }}</span>
  <span *ngIf="basisCode && manufacturer"> / </span>
  <span *ngIf="manufacturer">{{ manufacturer }}</span>
</div>
